import { ProjectActions } from '@octopus-do/octopus-project-core'

import { InitialColorIds } from '../colors'

export const InitSettingsAction = ProjectActions.settings.updateDefaultColor({
  defaultColor: InitialColorIds.default,
})
